import { useTranslation } from 'react-i18next';
import { useMyAdsPromotionDetails } from './useMyAdsPromotionDetails';
import { useMyAdsPromotionPayment } from './useMyAdsPromotionPayment';
import { getPromotionsData } from '@/components/Ad/Promotions/PromotionFlow.helpers';
import { getMyAdsPromotionPaidUntilDate } from '@/features/Profile/sections/MyAds/components/MyAdsPromotionFlow/MyAdsPromotionFlow.helpers';
import {
  MyAdsPromotionFlowProps,
  MyAdsPromotionModalDrawerTitle,
} from '@/features/Profile/sections/MyAds/components/MyAdsPromotionFlow/MyAdsPromotionFlow.types';
import { usePlatformSource } from '@/hooks/usePlatformSource';

export function useMyAdsPromotionFlow(props: MyAdsPromotionFlowProps) {
  const { ad, isOpen } = props;
  const { t } = useTranslation();
  const source = usePlatformSource();
  const { adDetails, isPromotionDetailsLoading, services } =
    useMyAdsPromotionDetails({ ad, isOpen });
  const paymentFlow = useMyAdsPromotionPayment({
    ...props,
    adDetails,
    services,
    source,
  });

  const { selectedType } = paymentFlow;
  const isPromotionPickerOpen = isOpen && !selectedType;
  const promotionsData = selectedType
    ? getPromotionsData({ t })[selectedType]
    : null;
  const paidUntilDate = getMyAdsPromotionPaidUntilDate({
    adDetails,
    t,
    type: selectedType,
  });
  const drawerTitle: MyAdsPromotionModalDrawerTitle = promotionsData
    ? {
        iconSrc: `/images/${promotionsData.iconName}.svg`,
        text: promotionsData.title,
      }
    : '';

  return {
    ...paymentFlow,
    adDetails,
    drawerTitle,
    isPromotionDetailsLoading,
    isPromotionPickerOpen,
    paidUntilDate,
    promotionsData,
    services,
  };
}
